import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 100 100" {...props}>
      <title id="Performing-Rights-Organizations">
        {props.title || 'Performing-Rights-Organizations'}
      </title>
      <g>
        <path d="M90.2 53.7c-.8-1.9-.8-4 0-5.9l3.8-9.2c1.6-4-.3-8.3-4-10l-9.2-3.8c-1.9-1.1-3.2-2.4-4-4.6L73 11c-1.6-4-6.2-5.9-10-4.3l-9.2 3.8c-1.9.8-4 .8-5.9 0l-9.2-3.8c-4-1.6-8.3.3-10 4l-3.8 9.2c-.8 1.9-2.4 3.5-4.3 4l-9.4 4c-3.8 1.6-5.7 5.9-4 10l3.8 9.2c.8 1.9.8 4 0 5.9l-3.8 9.2c-1.6 4 .3 8.3 4 10l9.2 3.8c1.9.8 3.5 2.4 4 4.3l3.8 9.2c1.6 4 6.2 5.9 10 4.3l9.2-3.8c1.9-.8 4-.8 5.9 0l9.2 3.8c4 1.6 8.3-.3 10-4l3.8-9.2c.8-1.9 2.4-3.5 4.3-4l9.2-3.8c4-1.6 5.9-6.2 4.3-10l-3.9-9.1zm-20.5 9.8c.1 2.6-2 5.6-5.2 7.4-4.2 2.4-8.9 2.1-10.5-.7-1.6-2.8.5-6.9 4.7-9.3 2.4-1.3 5-1.9 7.1-1.5V39.6H42.5v24c0 2.6-2 5.5-5.2 7.3-4.2 2.4-8.9 2.1-10.5-.7-1.6-2.8.5-6.9 4.7-9.3 2.4-1.3 5-1.9 7.1-1.5V31h31.1v32.5z" />
      </g>
    </Icon>
  )
}



// WEBPACK FOOTER //
// ./client/components/icons/performingRightsOrganizations.js